import { render, staticRenderFns } from "./OtherIncomeTable.vue?vue&type=template&id=4d079b3d&scoped=true"
import script from "./OtherIncomeTable.vue?vue&type=script&lang=js"
export * from "./OtherIncomeTable.vue?vue&type=script&lang=js"
import style0 from "./OtherIncomeTable.vue?vue&type=style&index=0&id=4d079b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d079b3d",
  null
  
)

export default component.exports